import axios from "axios";
import Vue from "vue";
import Vuex from "vuex";
import "es6-promise/auto";
import PriceData from "./components/logic/payment/RefreshShoppingCartPrice";
import eventBus from "./EventBus";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import CryptoJS from 'crypto-js';
import helper from "./components/mixins/helper";

import i18n from "./i18n";
// plugin a agregar de vuex-persistedstate mantener vivas las propiedades
import VuexPersistence from "vuex-persist";
Vue.use(Vuex);
// Clave secreta para la encriptación
const SECRET_KEY = process?.env?.MIX_APP_KEY_SALT;

export default new Vuex.Store({
    // aquí agregamos el plugin
    plugins: [
        new VuexPersistence({
            key: "store",
            storage: window.localStorage,
            reducer(val) {
                if (val.userLoggedIn === false) {
                    // val.user.token (your user token for example)
                    // return {};
                }
                return val;
            },
            restoreState(key, storage) {
                const encryptedData = storage.getItem(key);
                if (encryptedData) {
                    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
                    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                    return decryptedData;
                }
                return undefined;
            },
            saveState(key, state, storage) {
                const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(state), SECRET_KEY).toString();
                storage.setItem(key, encryptedData);
            }
        }).plugin,
    ],
    state: {
        Language: "",
        translate: [],
        IPAddress: document
            .querySelector('meta[name="address"]')
            .getAttribute("content"),
        componentes: {
            toolbarPrice: 0,
            modalAddNewAlbum: false,
            displayDownloadBox: false,
            album: "",
            shoppingCart: "",
            modalLogin: true,
        },
        randomKey: 0,
        typeCodeTab: 0,
        tabDownloadCode: false,
        tabTags: false,
        tabReservations: false,
        tabFreeGallery: true,
        newKeyComponent: 0,
        userLoggedIn: false,
        isGuest: true,
        email: "",
        loading: false,
        needReloadAlbumes: false,
        codes: {}, //Propiedad para almacenar todos los codigos consultados y guardados en localstorage
        shoppingCart: {}, //Propiedad para alamacenar todoslos productor seleccionados y alamacenados en storage para venta
        shoppingCartAmount: 0,
        CurrentPrice: {},
        CartTypes: {},
        Currency: "",
        Currencies: [],
        albumes: [],
        gallery: [],
        Parks: [],
        Banks: {},
        SafetyPayBanks: {},
        CardTypes: [],
        zip: {
            data: [],
            compressed: 0,
            total: 0,
        },
        downloaded: {
            contentLength: 0,
            byteLength: 0,
            spinning: false,
            data: [],
            progressing: false,
            compressing: false,
            compressingZip: {
                compressed: 0,
                total: 0,
            },
            progress: 0,
            completed: false,
        },
        payment: {
            countries: [],
            states: [],
            Amount: 0,
            pax: {
                website: [],
                shoppingCart: [],
            },
        },
    },
    mutations: {
        SET_LANGUAGE(state, data) {
            state.Language = data;
        },
        SET_UPDATE_ALBUM_COMPONENT(state, data) {
            state.componentes.album = uuidv4();
        },
        SET_UPDATE_SHOPPING_CART_COMPONENT(state, data) {
            state.componentes.shoppingCart = uuidv4();
        },
        SET_LOGOUT(state) {
            state.albumes = [];
            state.shoppingCart = {};
            state.shoppingCartAmount = 0;
            state.userLoggedIn = true;
            state.isGuest = true;
            state.componentes.modalLogin = true;
            state.typeCodeTab = null;
            state.tabDownloadCode = false;
            state.tabTags = false;
            state.tabReservations = false;
            state.email = "";
            state.componentes.displayDownloadBox = false;
            state.Parks = [];
        },
        SET_TRANSLATE(state, data) {
            state.translate = data;
        },
        SET_ALBUM(state, data) {
            
            state.albumes = state.albumes.length ?
                data.concat(state.albumes) :
                data;
            
        },
        REFRESH_ALBUM(state, { idx, data }) {
            state.albumes[idx] = data;
        },
        DELETE_ALBUM(state, data) {
            state.albumes.splice(data, 1);
        },
        SET_GALLERY(state, data) {
            state.gallery[data.current_page] = data;
        },
        SET_SHOPPING_CART_AMOUNT(state, data) {
            state.shoppingCartAmount = data;
        },
        SET_LOADING(state, data) {
            state.loading = data;
        },
        SET_SELECTED_PARKS(state, { idx, data }) {
            delete state.albumes[idx].selectedParks;
            state.albumes[idx].selectedParks = data;
        },
        SET_UNLOCK_PARK(state, { idx, parkId }) {
            state.albumes[idx].park.forEach(function callback(item) {
                
                if (item.Park.Id == parkId) {
                    item.Unlocked = true;
                }
            });
        },
        SET_USER_LOGGED_IN(state, data) {
            state.userLoggedIn = data;
        },
        SET_USER_GUEST(state, data) {
            state.isGuest = data;
        },
        SET_MODAL_LOGIN(state, data) {
            state.componentes.modalLogin = data;
        },
        SET_USER_EMAIL(state, data) {
            state.email = data;
        },
        SET_AUTH_GUEST(state) {
            state.isGuest = true;
            state.userLoggedIn = true;
            state.componentes.modalLogin = false;
        },
        SET_MODAL_ADD_ALBUM(state, data) {
            state.componentes.modalAddNewAlbum = data;
        },
        SET_TYPE_CODE_TAB(state, data) {
            state.typeCodeTab = data;
        },
        SET_DOWNLOAD_CODE_TAB(state, data) {
            state.tabDownloadCode = data;
        },
        SET_TAGS_TAB(state, data) {
            state.tabTags = data;
        },
        SET_RESERVATIONS_TAB(state, data) {
            state.tabReservations = data;
        },
        CREATE_NEW_KEY_COMPONENT(state, data) {
            state.newKeyComponent = data;
        },
        SET_SHOPPING_CART(state, data) {
            state.shoppingCart = data;
        },
        SET_ALBUMES(state, data) {
        },
        SET_ALBUMES_FREE(state, room) {
            state.albumes.forEach(function callback(item, idx, array) {
                if (item.code == room) {
                    
                    state.albumes[idx].park.forEach(function callback(
                        item,
                        idx2,
                        array
                    ) {
                        
                        if (item.IsHotel) {
                            state.albumes[idx].park[idx2].IsAdded = false;
                        }
                    });
                }
            });
        },
        /**
         * We get all the tags in the shopping cart, then we loop through them and delete them from the
         * albumes array.
         * @param state - The state object
         */
        SET_REMOVE_TAGS_PURCHASED_ALBUMS(state) {
            // Obtenemos todos los brazaletes que se encuentran en el carrito
            const tags = Object.values(state.shoppingCart)
                .filter((item) => item.type === 1)
                .map((tag) => {
                    return tag.Tags;
                })
                .flat();

            // Recorremos todos los brazaletes
            tags.map(function(data) {
                
                // Recuperamos la posicion del album
                const idx = state.albumes.findIndex(
                    (item) =>
                    item.code == data.tag &&
                    item.VisitDate == data.visitedOn
                );
                
                // Eliminamos el brazalete despues que se realizo la compra
                delete state.albumes[idx];
            });

            /*
             *Verificamos si se compraron todos los tags o quedaron para comprar
             *para que podamos deshabilitar la pestña de TAGS
             */
            const hasSomeTag = state.albumes.some((item) => item.type === 1);
            if (!hasSomeTag) {
                state.tabTags = false;
            }
        },
        SET_CLEAR_SHOPPING_CART(state) {
            state.shoppingCart = {};
            state.payment.Amount = 0;
            state.shoppingCartAmount = 0;
        },
        /**
         * It clears the shopping cart.
         * @param state - The state object.
         */
        SET_CLEAR_ALBUMES(state) {
            let videosIdList = Object.values(state.shoppingCart)
                .filter((item) => item.type === 3)
                .map((item) => {
                    state.albumes.map((album) => {
                        if (item.AlbumUuid === album.uuid) {
                            album.park.map((park) => (park.IsAdded = true));
                        }
                    });
                });

            let albumsBkp = [];
            state.albumes.map((album, idx) => {
                // Reservations | Regular Parks
                if ((album.Type == 2) | (album.Type == 1)) {
                    // Verificamos si de este album hay alguno agregado al carrito para poder eliminar el album
                    let addedParks = album.park.some((park) => park.IsAdded);
                    
                    if (!addedParks) {
                        albumsBkp.push(album);
                    }
                }
                // Download Codes
                else if (album.Type == 0) {
                    album.park.map((park) => {
                        delete park.Amount;
                        park.IsAdded = false;
                    });

                    albumsBkp.push(album);
                }
            });

            
            

            state.albumes = albumsBkp;

            // Verificamos si hay reservas o Codigos con tags para ver si deshabilitamos sus Tabs
            const hasReserves = state.albumes.some((park) => park.Type == 2);
            const hasTags = state.albumes.some((park) => park.Type == 1);

            state.tabTags = hasTags;
            state.tabReservations = hasReserves;

            // Habilitamos el tab de codigos de descarga
            state.typeCodeTab = 0;
            state.tabDownloadCode = true;

            // Limpiamos las propiedades del carrito
            state.shoppingCart = {};
            state.payment.Amount = 0;
            state.shoppingCartAmount = 0;
        },
        /**
         * It filters the array of albums by the type of album (0 = deleted) and then removes the album
         * from the array
         * @param state - The current state of the store.
         */
        SET_DELETE_DOWNLOAD_CODES_IN_ALBUMS(state) {
            let albums = state.albumes.filter((album) => album.Type !== 0);
            state.albumes = albums;
        },
        SET_CODES(state, data) {
            state.codes = data;
        },
        SET_STATUS_RELOAD_ALBUMES(state, status) {
            state.needReloadAlbumes = status;
        },
        SET_SPINNING_MULTIMEDIA(state, data) {
            state.downloaded.spinning = data;
        },
        SET_CURRENCIES(state, data) {
            state.Currencies = data;
        },
        SET_CURRENCY(state, data) {
            state.Currency = data;
        },
        SET_PROGRESSING_MULTIMEDIA(state, data) {
            state.downloaded.progressing = data;
        },
        SET_COMPRESSING_MULTIMEDIA(state, data) {
            state.downloaded.compressing = data;
        },
        SET_NEW_DATA_DOWNLOADED(state, { idx, data }) {
            state.downloaded.data[idx].byteLength = data.byteLength;
            state.downloaded.data[idx].porcent = data.porcent;
        },
        SET_NEW_DATA_ZIP(state, { idx, progress }) {
            
            
            state.zip.data[idx].porcent = progress;
        },
        SET_ZIP(state, data) {
            state.zip.data = data;
        },
        SET_DOWNLOADED(state, data) {
            state.downloaded.data = data;
        },
        SET_EMPTY_DOWNLOAD(state) {
            state.downloaded.data = [];
            state.zip.compressed = 0;
            state.zip.data = [];
            state.zip.total = 0;
            state.downloaded.compressingZip.compressed = 0;
            state.downloaded.compressingZip.total = 0;
        },
        SET_DOWNLOAD_BOX_STATUS(state, show) {
            state.componentes.displayDownloadBox = show;
        },
        SET_DOWNLOADED_PROGRESS(state, data) {
            state.downloaded.progress = data;
        },
        SET_DOWNLOADED_CONTENT_LENGTH(state, { idx, data }) {
            state.downloaded.data[idx].contentLength = data.contentLength;
            state.downloaded.data[idx].sizeFormat = data.formatBytes;
        },
        SET_DOWNLOADED_URL(state, { idx, data }) {
            state.downloaded.data[idx].url = data;
        },
        SET_DOWNLOADED_STATE(state, { idx, data }) {
            state.downloaded.data[idx].state = data;
        },
        SET_DOWNLOADED_COMPRESSINGZIP_COMPRESSED(state, compressedZipQuantity) {
            state.downloaded.compressingZip.compressed = compressedZipQuantity;
        },
        SET_DOWNLOADED_COMPRESSINGZIP_TOTAL(state, totalZip) {
            state.downloaded.compressingZip.total = totalZip;
        },
        SET_DOWNLOADED_BYTE_LENGTH(state, data) {
            state.downloaded.byteLength = data;
        },
        SET_ZIP_COMPRESSED(state, data) {
            
            state.zip.compressed = data;
        },
        SET_ZIP_TOTAL(state, data) {
            
            state.zip.total = data;
        },
        SET_COMPLETED_DOWNLOAD(state, data) {
            state.downloaded.completed = data;
        },
        SET_CONTRIES(state, data) {
            state.payment.countries = data;
        },
        SET_COUNTRY_STATES(state, data) {
            state.payment.states = data;
        },
        SET_AMOUNT(state, data) {
            state.payment.Amount = data;
        },
        SET_PAX_PAYMENT(state, data) {
            state.payment.pax.website = {...data };
        },
        SET_PARKS(state, data) {
            state.Parks = data;
        },
        SET_BANKS(state, data) {
            state.Banks = data;
        },
        SET_SAFETY_PAY_BANKS(state, data) {
            state.SafetyPayBanks = data;
        },
        SET_CARD_TYPE_BANKS(state, data) {
            state.CardTypes = data;
        },
        SET_CURRENT_PRICE(state, data) {
            state.shoppingCart[data.ParkID].Id = data.Id;
            state.shoppingCart[data.ParkID].Amount = data.Amount;
            state.shoppingCart[data.ParkID].RateKey = data.RateKey;
            state.shoppingCart[data.ParkID].NormalIndividual =
                data.NormalIndividual;
        },
        setCarrito(state, payload) {
            // Venta de video
            if (payload.type === 3) {
                state.shoppingCart[payload.VideoId] = {...payload };
                
            }
            // Verificamos si el tipo de producto es una Reserva
            else if (payload.type === 2) {
                state.shoppingCart[payload.BookID] = {...payload };
                
            } else if (payload.type === 0) {
                state.shoppingCart[payload.code] = {...payload };
                
            } else {
                // Si el producto contiene la propiedad ServiceId sera considerada como un producto individual
                const idxCart =
                    payload.ServiceId != null ? payload.uuid : payload.ParkID;
                state.shoppingCart[idxCart] = {...payload };
                
            }
        },
        SET_REMOVE_ITEM_SHOPPING_CART(state, data) {
            
            delete state.shoppingCart[data];
        },
        REMOVE_ITEM_BY_TAG_CART(state, { visitDate, parkId }) {
            let shoppingCartList = {};
            Object.keys(state.shoppingCart).forEach((item, idx) => {
                if (
                    state.shoppingCart[item].type == 1 &&
                    state.shoppingCart[item].ParkID == parseInt(parkId) &&
                    state.shoppingCart[item].VisitDate == visitDate
                ) {
                    
                    delete state.shoppingCart[item];
                } else if (
                    state.shoppingCart[item].type == 3 &&
                    state.shoppingCart[item].VideoDetails.parkId ==
                    parseInt(parkId) &&
                    state.shoppingCart[item].VisitDate == visitDate
                ) {
                    
                    delete state.shoppingCart[item];
                }
            });
        },
        SET_UPDATE_ALBUM_PV(state, data) {
            state.albumes[data.idxAlbum] = data.albumData;
        },
        SET_SELECT_PARK_ROOM(state, data) {
            this.$set(data.IsAdded, "IsAdded", data.IsAdded ? false : true);
        },
        SET_ENABLE_ADD_BUTTOM_CART(state, data) {
            let SelectedParks = data.park.some((item) => item.IsAdded);
            data.IsAdded = SelectedParks;

            if (!SelectedParks) {
                delete state.shoppingCart[data.code];
                data.Amount = 0;
                data.GrossAmount = 0;
                eventBus.$emit("addShoppingCart");
            }
        },
        /**
         * Funcion para calcular de manera dinamica el precio del carrito.
         */
        RECALCULATE_CART_PAYMENT(state, itemCartDeleted) {
            state.shoppingCart.map((item) => {
                const itemUpdated = {
                    id: Date.now() +
                        "-" +
                        Math.random().toString(36).substring(2, 5),
                    cantidad: item.cantidad - 1,
                    ParkID: item.ParkID,
                    type: 1,
                    TotalMedia: item.TotalMedia - itemCartDeleted.totalMedia,
                    Id: 0,
                    Amount: 0,
                    NormalIndividual: 0,
                    RateKey: "",
                };
                let newPrice = dispatch("GetNewPrice", itemUpdated);
                commit("setCarrito", newPrice);
            });
        },
    },
    actions: {
        setLanguage({ commit }, languages) {
            if (typeof languages === "string") {
                commit("SET_LANGUAGE", languages);
            } else {
                const language = supportedLanguages.find((sl) =>
                    languages.find((l) =>
                        l.split(new RegExp(sl, "gi")).length - 1 > 0 ? sl : null
                    )
                );
                commit("SET_LANGUAGE", language);
            }
        },
        updateAlbumComponent({ commit }, data) {
            commit("SET_UPDATE_ALBUM_COMPONENT");
        },
        updateShoppingCartComponent({ commit }, data) {
            commit("SET_UPDATE_SHOPPING_CART_COMPONENT");
        },
        /**
         * The setLogout function sets the logout state to true and dispatches the setEmptyDownload action.
         */
        setLogout({ commit, dispatch }) {
            /* Setting the logout state to true. */
            commit("SET_LOGOUT");
            /* Dispatching the setEmptyDownload action. */
            dispatch("setEmptyDownload");
        },
        getToken() {
            return (
                Date.now() + "-" + Math.random().toString(36).substring(2, 5)
            );
        },
        /**
         * It takes in a data object, and then sends it to the server
         * @param data
         * @returns A promise.
         */
        async VisitorActivity({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/VisitorActivity", data)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        async getAlbums({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/GetAlbums", data)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        /**
         * It gets the data from the API and commits it to the store
         */
        async getTranslate({ commit }) {
            try {
                const { data: data } = await axios.get("/api/GetLanguages");
                commit("SET_TRANSLATE", data);
            } catch (error) {
                
            }
        },
        /**
         * It's an async function that takes in a commit and data as parameters. It returns a promise
         * that resolves to the data returned by the axios post request
         * @param data
         * @returns The data is being returned from the API.
         */
        async Booking({ commit, state, dispatch }, data) {
            // Datos para el header de la solicitud
            const headers = {
                currency: state.Currency,
            };

            // tiempo para rechazar la solicitud
            let timeout = 4 * 60 * 1000;

            // Configuración de la solicitud
            const axiosConfig = {
                method: 'post',
                url: '/api/payment/Booking',
                headers: headers,
                data: data,
                timeout: timeout,
            };

            try {
                // Realizar la solicitud Axios
                const response = await axios(axiosConfig);
                // Manejar la respuesta exitosa aquí
                return Promise.resolve(response.data);
            } catch (error) {
                if (axios.isCancel(error)) {
                    // Deshabilitar el loading
                    dispatch("setLoading", false);
                    // Manejar timeout
                    const timeoutError = new Error('La petición ha excedido el tiempo límite.');
                    // Habilitar el modal de error
                    document.getElementById('modalSaleError').classList.remove("hidden");
                    // Rechazar la promesa con el error de timeout
                    return Promise.reject(timeoutError);
                } else {
                    // Deshabilitar el loading
                    dispatch("setLoading", false);
                    // Rechazar la promesa con el error general
                    return Promise.reject(error);
                }
            }
        },
        async GatewayPayment({ commit, state }, data) {
            const headers = {
                currency: state.Currency,
            };

            return new Promise((resolve, reject) => {
                axios
                    .post("/api/payment/GatewayPayment", data, headers)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        async SaleAdd({ commit, state }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/payment/SaleAdd", data)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        async RecoverySale({ commit, state }, data) {
            const headers = {
                currency: state.Currency,
            };
            
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/payment/RecoverySale", data, headers)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        /**
         * It's an async function that takes in a commit and data object, and returns a promise that
         * resolves to the data returned from the axios post request
         * @param data
         */
        async getAlbumes({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/GetInitialParks", data)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        async AddMediaLog({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/AddMediaLog", data)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        /**
         * It's an async function that takes in a commit and data, and returns a promise that resolves
         * to the data returned from the axios post request
         * @param data
         */
        async getMediaFree({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/GetMediaFree", data)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        /**
         * It takes a code, sends it to the server, and returns a boolean value
         * @param data
         * @returns A promise.
         */
        async isValidCode({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/IsValidDownloadCode", data)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        /**
         * It takes in a commit and data object, and returns a promise that resolves to the data
         * returned from the API call
         * @param data
         * @returns A promise.
         */
        async getPhotos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/GetMultimedia", data)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        /**
         * It takes in a commit and a data object, and returns a promise that resolves to the data
         * returned from the API call
         * @returns The promise is being returned.
         */
        getCompressMedia({ commit }, { data }) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/GetPhotosByZip", { data })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        /**
         * The function takes in a commit object and a data object. The commit object is used to call
         * the SET_ALBUM mutation. The data object is passed to the SET_ALBUM mutation
         * @param data - The data that is being passed to the mutation.
         */
        setAlbum({ commit }, data) {
            commit("SET_ALBUM", data);
        },
        refreshAlbum({ commit }, { idx, data }) {
            commit("REFRESH_ALBUM", { idx, data });
        },
        deleteAlbum({ commit, state, dispatch }, data) {
            const parkId = state.albumes[data].ParkID;

            if (state.shoppingCart.hasOwnProperty(parkId)) {
                delete state.shoppingCart[parkId];
            }

            commit("DELETE_ALBUM", data);
            dispatch("addShoppingCartAmount");
            dispatch("getAmount");
            dispatch("getAmount");

            // Actualizamos el componente de Albums
            dispatch("updateAlbumComponent");
            // Actualizamos el componente del carrito
            dispatch("updateShoppingCartComponent");
            // delete state.shoppingCart[data];
        },
        /**
         * It takes in a commit and data object, and returns a promise that resolves to the data
         * returned from the API call
         * @param data
         */
        async updateVideoTag({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/UpdateVideoTag", data)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        /**
         * It takes in a commit and data, and returns a promise that resolves to the data returned from
         * the axios post request
         * @param data
         */
        async getSelectedParks({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/UpdateVideoTag", data)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        /**
         * It takes a data object, sends it to the server, and then commits a mutation to the store
         * @param data
         */
        async addVisitPark({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/AddVisitPark", data)
                    .then((res) => {
                        const response = res.data;
                        const selectedParks = response.selectedParks;

                        if (response.addVisitPark.Status) {
                            commit("SET_SELECTED_PARKS", {
                                idx: data.idx,
                                data: selectedParks,
                            });
                            commit("SET_UNLOCK_PARK", {
                                idx: data.idx,
                                parkId: data.parkId,
                            });
                        }

                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        /**
         * It's an async function that takes in a commit and state object, and an optional data object.
         * It then sets the state.Currency to the data object if it's not null, and then sets the
         * headers to the state.Currency. It then returns a promise that resolves to the data object
         * @param [data=null] - The data that is passed to the function.
         */
        async getBanks({ commit, state }, data = null) {
            
            commit("SET_CURRENCY", data);
            const iso = data != null ? data : state.Currency;
            const headers = {
                currency: iso,
            };

            return new Promise((resolve, reject) => {
                axios
                    .post(
                        "/api/payment/PaymentBanks", { Amount: state.payment.Amount }, { headers: headers }
                    )
                    .then((res) => {
                        commit("SET_BANKS", res.data.banks);
                        commit("SET_SAFETY_PAY_BANKS", res.data.safetyPayBanks);
                        commit("SET_CARD_TYPE_BANKS", res.data.cardTypes);

                        resolve(res.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        /**
         * It gets all the parks from the database and commits them to the state
         * @param [data=null] - This is the data that is passed to the action.
         */
        async getParks({ commit, state }, data = null) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/GetAllParks")
                    .then((response) => {
                        const { data } = response;
                        commit("SET_PARKS", data);

                        resolve(data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        setLoading({ commit }, data) {
            commit("SET_LOADING", data);
        },
        setModalAddAlbum({ commit }, data) {
            commit("SET_MODAL_ADD_ALBUM", data);
        },
        setTypeCodeTab({ commit }, data) {
            commit("SET_TYPE_CODE_TAB", data);
        },
        setDownloadCodeTab({ commit }, data) {
            commit("SET_DOWNLOAD_CODE_TAB", data);
        },
        setTagsTab({ commit }, data) {
            commit("SET_TAGS_TAB", data);
        },
        setReservationsTab({ commit }, data) {
            commit("SET_RESERVATIONS_TAB", data);
        },
        setUserLoggedIn({ commit }, data) {
            commit("SET_USER_LOGGED_IN", data);
        },
        setUserGuest({ commit }, data) {
            commit("SET_USER_GUEST", data);
        },
        setModalLogin({ commit }, data) {
            commit("SET_MODAL_LOGIN", data);
        },
        setUserEmail({ commit }, data) {
            commit("SET_USER_EMAIL", data);
        },
        setAuthGuest({ commit }) {
            commit("SET_AUTH_GUEST");
        },
        /*Accion para obtener todos los datos consultados por primera 
        vez de un codigo de descarga | Brazalete | Room*/
        setShoppingCart({ commit }, data) {
            commit("SET_SHOPPING_CART", data);
        },
        setAlbumes({ commit }, data) {
            commit("SET_ALBUMES", data);
        },
        setAlbumesFree({ commit, dispatch }, room) {
            commit("SET_ALBUMES_FREE", room);
            dispatch("addShoppingCartAmount");
            dispatch("getAmount");
        },
        setCodes({ commit }, data) {
            commit("SET_CODES", data);
        },
        setStatusReloadAlbumes({ commit }, status) {
            commit("SET_STATUS_RELOAD_ALBUMES", status);
        },
        setSpinningMultimedia({ commit }, data) {
            commit("SET_SPINNING_MULTIMEDIA", data);
        },
        setProgressingMultimedia({ commit }, data) {
            commit("SET_PROGRESSING_MULTIMEDIA", data);
        },
        setCompressingMultimedia({ commit }, data) {
            commit("SET_COMPRESSING_MULTIMEDIA", data);
        },
        setNewDataZip({ commit }, { idx, data }) {
            commit("SET_NEW_DATA_ZIP", { idx, data });
        },
        setNewDataDownloaded({ commit }, { idx, data }) {
            commit("SET_NEW_DATA_DOWNLOADED", { idx, data });
        },
        setZip({ commit }, data) {
            commit("SET_ZIP", data);
        },
        setDownloaded({ commit }, data) {
            commit("SET_DOWNLOADED", data);
        },
        setEmptyDownload({ commit }) {
            commit("SET_EMPTY_DOWNLOAD");
        },
        setDownloadsBoxStatus({ commit }, show) {
            commit("SET_DOWNLOAD_BOX_STATUS", show);
        },
        setDownloadProgress({ commit }, data) {
            commit("SET_DOWNLOADED_PROGRESS", data);
        },
        setDownloadContentLength({ commit }, { idx, data }) {
            
            commit("SET_DOWNLOADED_CONTENT_LENGTH", { idx, data });
        },
        setDownloadUrl({ commit }, { idx, data }) {
            
            commit("SET_DOWNLOADED_URL", { idx, data });
        },
        setDownloadState({ commit }, { idx, data }) {
            commit("SET_DOWNLOADED_STATE", { idx, data });
        },
        setDownloadedCompressingZipCompressed({ commit },
            compressedZipQuantity
        ) {
            commit(
                "SET_DOWNLOADED_COMPRESSINGZIP_COMPRESSED",
                compressedZipQuantity
            );
        },
        setDownloadedCompressingZipTotal({ commit }, totalZip) {
            
            commit("SET_DOWNLOADED_COMPRESSINGZIP_TOTAL", totalZip);
        },
        setDownloadByteLength({ commit }, data) {
            commit("SET_DOWNLOADED_BYTE_LENGTH", data);
        },
        setZipCompressed({ commit }, data) {
            
            commit("SET_ZIP_COMPRESSED", data);
        },
        setZipTotal({ commit }, data) {
            
            commit("SET_ZIP_TOTAL", data);
        },
        setCompletedDownload({ commit }, data) {
            commit("SET_COMPLETED_DOWNLOAD", data);
        },
        setContries({ commit }, data) {
            let topCountries = helper.methods.topCountries(data);
            commit("SET_CONTRIES", topCountries);
        },
        setCountryStates({ commit }, data) {
            commit("SET_COUNTRY_STATES", data);
        },
        setCurrencies({ commit }, data) {
            commit("SET_CURRENCIES", data);
        },
        setCurrency({ commit, dispatch }, data) {
            commit("SET_CURRENCY", data);
            dispatch("updatePriceShoppingCart");
        },
        setAmount({ commit, state }) {
            // Actualizamos la propiedad
            commit("SET_AMOUNT");
        },
        setPaxPayment({ commit }, data) {
            commit("SET_PAX_PAYMENT", {...data });
        },
        setUpdatePriceShop({ commit }, {...data }) {},
        LoadNewCodes: () => {
            eventBus.$emit("LoadNewCodes");
        },
        reloadGallery: ({ commit }, data) => {
            eventBus.$emit("reloadGallery", data);
        },
        /* Making a post request to the server and getting the price of the item. */
        // 0 Type - Codigo de descarga
        // 1 Type - Tag
        // 2 Type - Reserva
        GetNewPrice: async({ state }, data) => {
            if (data.type == 3) {
                var arg = {
                    ServiceNumber: data.cantidad,
                    LocationId: data.LocationId,
                    IsOnlyHotel: false,
                    ParkID: data.ParkID,
                    type: data.type,
                };
            }
            // Verificamos si es se calculara el precio de una Reserva
            else if ((data.type == 2 || data.type == 0) && data.IsOnlyHotel) {
                var arg = {
                    ServiceNumber: 1,
                    ParkID: data.ParkID,
                    Parks: data.Parks,
                    IsOnlyHotel: true,
                    type: data.type,
                    Pax: data.Pax,
                };
            } else if (data.type == 2 || data.type == 0) {
                var arg = {
                    ServiceNumber: data.cantidad,
                    ParkID: data.ParkID,
                    Parks: data.Parks,
                    IsOnlyHotel: false,
                    type: data.type,
                    Pax: data.Pax,
                };
            } else {
                // Verificamos si es se calculara el precio de un paquete individual
                var arg = {
                    ServiceNumber: 1,
                    ParkID: data.ParkID,
                    Parks: data.Parks,
                    IsOnlyHotel: data.IsOnlyHotel,
                    type: data.type,
                    Pax: data.Pax,
                };

                if (!data.hasOwnProperty("IsOnlyHotel")) {
                    arg.IsOnlyHotel = false;
                }

                if (data.ServiceId != null) {
                    arg.ServiceNumber = 1;
                    arg.ServiceId = data.ServiceId;
                    arg.uuid = data.uuid;
                }
            }

            const headers = {
                currency: state.Currency,
            };

            return new Promise((resolve, reject) => {
                axios
                    .post(
                        "/api/payment/GetNewPrice", {
                            data: arg,
                        }, { headers: headers }
                    )
                    .then((res) => {
                        let ItemAndPrice = {...data, ...res.data };
                        resolve(ItemAndPrice);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        /**
         * I'm trying to update the price of each item in the shopping cart
         */
        async updatePriceShoppingCart({ commit, dispatch, state }) {
            let shoppingCart = Object.keys(state.shoppingCart);

            let newPrices = shoppingCart.map(async(element) => {
                const data = state.shoppingCart[element];

                let item = await dispatch("GetNewPrice", data);

                commit("setCarrito", item);
                await dispatch("addShoppingCartAmount");
                await dispatch("getAmount");
                
            });
        },
        async applyVideoPriming({ commit, dispatch, state }, videoAdded) {
            const shoppingCart = Object.values(state.shoppingCart);
            // Si el video no tienen promomcion se debe agregar
            if (videoAdded.Promotions !== null) {
                // recuperamos el id y la promocion del producto agregado al carrito, solo videos
                let videoIdShoppingCart = shoppingCart
                    .filter((video) => video.type === 3)
                    .map((video) => {
                        return {
                            videoId: video.VideoId,
                            serviceId: video.VideoDetails.serviceId,
                            promotions: video.Promotions,
                        };
                    });

                let serviceCount = videoIdShoppingCart.filter(
                    (el) => el.serviceId == videoAdded.VideoDetails.serviceId
                );

                if (serviceCount.length < videoAdded.Promotions.Pay) {
                    return true;
                } else {
                    return false;
                }
            }
            return true; 
        },
        /**
         * It adds a product of video to the shopping cart
         * @param product
         */
        async addCartByVideo({ commit, dispatch, state }, product) {
            try {
                dispatch("setLoading", true);
                // Obtenemos el ParkId y el VideoId del producto
                const parkId = product.ParkId;
                const videoId = product.VideoId;

                // Generamos la estructura para agregar el video al carrito
                let item = {
                    id: uuidv4(),
                    cantidad: 1,
                    ParkID: parkId,
                    Tag: product.Tag,
                    VisitDate: product.VisitDate,
                    VideoId: videoId,
                    LocationId: product.LocationId,
                    AlbumUuid: product.AlbumUuid,
                    VideoDetails: {
                        serviceId: null,
                        serviceType: 1,
                        visitDate: product.VisitDate,
                        tags: [{
                            tag: product.Tag,
                            visitedOn: product.VisitDate,
                            parkId: parkId,
                            tagType: 1,
                            mediaCollection: [videoId],
                        }, ],
                        parkId: parkId,
                        guest: [],
                        availableParks: [],
                    },
                    type: 3,
                    TotalMedia: 1,
                    Id: 0,
                    date: moment().format("YYYY-MM-DD"),
                    Amount: 0,
                    NormalIndividual: 0,
                    RateKey: "",
                };

                // Obtenemos el precio del video
                let priceSivex = await dispatch("GetNewPrice", item);
                // Obtenemos el servicio del video
                priceSivex.VideoDetails.serviceId = priceSivex.ServiceID;
                // Seteamos el valor para que aparesca como agregado el album
                Vue.set(product, "IsAdded", true);

                // Verificamos si el video tiene promocion
                let hasPromo = await dispatch("applyVideoPriming", priceSivex);

                // Verificamos si el video tiene promocion y si es asi lo agregamos al carrito
                if (hasPromo) {
                    // Guardamos en el carrito
                    commit("setCarrito", priceSivex);

                    await dispatch("addShoppingCartAmount");
                    await dispatch("getAmount");

                    Vue.$toast.open({
                        message: i18n.t("messages.album_add_successfully"),
                        type: "success",
                    });
                } else {
                    // Mostramos un mensaje de que el video tiene promocion y no se puede agregar al carrito
                    Vue.$toast.open({
                        message: i18n.t("messages.album_add_promotion_info"),
                        type: "info",
                    });
                }

                dispatch("setLoading", false);

                return priceSivex;
            } catch (error) {
                dispatch("setLoading", false);

                Vue.set(product, "IsAdded", false);

                Vue.$toast.open({
                    message: i18n.t("messages.album_error_add"),
                    type: "error",
                });
            }
        },
        /**
         * It's a function that adds a product to the shopping cart
         */
        async addCartByDownloadCode222({ commit, dispatch, state }, { park, idx }) {
            try {
                dispatch("setLoading", true);

                Vue.set(park, "IsAdded", true);

                const parkId = park.Park.Id;
                const downloadCode = state.albumes[idx].code;
                const isAddedCode =
                    state.shoppingCart.hasOwnProperty(downloadCode);

                let totalMedia = isAddedCode ?
                    state.shoppingCart[downloadCode].TotalMedia :
                    0;
                
                let TotalPhotos = totalMedia + park.TotalMedia;

                let pax = park.Reservation.Pax;
                let cantidad =
                    Object.keys(state.shoppingCart).indexOf(
                        state.albumes[idx].code
                    ) > -1 ?
                    state.shoppingCart[state.albumes[idx].code].cantidad +
                    1 :
                    1;

                // Nos sirve para verificar si lo que se esta comprando es hotel para poder darle valor a la variable IsHotel
                let hasHotels = state.albumes[idx].park.some(
                    (data) => data.IsAdded && data.Park.IsHotel
                );

                let item = {
                    id: uuidv4(),
                    code: downloadCode,
                    cantidad: cantidad,
                    Pax: pax,
                    IsOnlyHotel: hasHotels,
                    ParkID: parkId,
                    type: 0,
                    TotalMedia: TotalPhotos,
                    Parks: [],
                    Id: 0,
                    date: moment().format("YYYY-MM-DD"),
                    Amount: 0,
                    NormalIndividual: 0,
                    RateKey: "",
                };

                let priceSivex = await dispatch("GetNewPrice", item);
                
                
                priceSivex.VisitDate = park.VisitDate;
                // Generamos el objeto con los items de precios del album cotizado
                const onlyPrice = {
                    Amount: priceSivex.Amount,
                    Id: priceSivex.Id,
                    Name: priceSivex.Name,
                    NormalIndividual: priceSivex.NormalIndividual,
                    RateKey: priceSivex.RateKey,
                    ServiceID: priceSivex.ServiceID,
                };

                // Limpiamos el array principal
                delete priceSivex.Id;
                delete priceSivex.Name;
                delete priceSivex.ParkID;
                delete priceSivex.RateKey;
                delete priceSivex.ServiceID;
                delete priceSivex.NormalIndividual;
                delete priceSivex.VisitDate;

                Vue.set(park, "price", onlyPrice);
                priceSivex.Parks = state.albumes[idx].park.filter(
                    (item) => item.IsAdded
                );
                priceSivex.Amount = priceSivex.Parks.reduce(
                    (acc, { price }) => acc + price.Amount,
                    0
                );

                commit("setCarrito", priceSivex);

                await dispatch("addShoppingCartAmount");
                await dispatch("getAmount");

                Vue.$toast.open({
                    message: i18n.t("messages.album_add_successfully"),
                    type: "success",
                });

                // Actualizamos el componente de Albums
                dispatch("updateAlbumComponent");
                // Actualizamos el componente del carrito
                dispatch("updateShoppingCartComponent");

                dispatch("setLoading", false);
            } catch (error) {
                dispatch("setLoading", false);

                Vue.set(park, "IsAdded", false);

                Vue.$toast.open({
                    message: i18n.t("messages.album_error_add"),
                    type: "error",
                });
                
            }
        },
        async addCartByDownloadCode({ commit, dispatch, state }, { park, idx }) {
            try {
                /* It's calling the action `setLoading` and passing the value `true` to it. */
                dispatch("setLoading", true);

                const downloadCode = state.albumes[idx].code;

                if (park.CustomService !== null) {
                    let uuid = uuidv4();
                    park.uuid = uuid;
                    await dispatch("addCartByServiceId", {
                        park,
                        tag: uuid,
                        reservation: true,
                    });
                    return;
                }

                Vue.set(park, "IsAdded", true);

                let Parks = state.albumes[idx].park.filter(
                    (data) =>
                    data.IsAdded &&
                    !data.Park.IsHotel &&
                    data.CustomService === null
                );

                if (Parks.length) {
                    state.albumes[idx].park.map(function(data) {
                        if (
                            data.Park.IsHotel &&
                            data.IsAdded &&
                            data.CustomService === null
                        ) {
                            data.IsAdded = false;
                            state.shoppingCart[downloadCode].cantidad--;
                        }
                    });
                }

                let Hotels = state.albumes[idx].park.filter(
                    (data) =>
                    data.IsAdded &&
                    data.Park.IsHotel &&
                    data.CustomService === null
                );

                // Si se encuentra solo agregado un hotel y sin parques se cotiza solo el numero de hoteles
                // De lo contrario si no se encuntran hoteles y so hay parques solo se cotizan los parques aun que se tengan hoteles seleccionados
                let parkSelected =
                    Hotels.length && !Parks.length ? Hotels : Parks;
                
                state.albumes[idx].FreeHotels = Parks.length;

                let pax = park.Reservation.Pax;

                // Verificamos si en los valores solo llega seleccion de hotel
                let item = {
                    code: downloadCode,
                    Room: parseInt(park.Reservation.Room),
                    BookID: parseInt(park.Reservation.BookId),
                    cantidad: parkSelected.length,
                    Pax: pax,
                    ParkID: park.Reservation.HotelId,
                    Parks: parkSelected,
                    IsOnlyHotel: Hotels.length,
                    type: 0,
                    date: moment().format("YYYY-MM-DD"),
                    Id: 0,
                    Amount: 0,
                    NormalIndividual: 0,
                    RateKey: "",
                };

                
                let priceSivex = {};
                /*
                 *   Obtenemos todos los precios regulares de los hoteles agregados y sumamos. Actualizamos el Amount total para que
                 *   la funcion Amount actualice los valores y se actualice el componente.
                 */
                if (Hotels.length) {
                    priceSivex = await dispatch("GetNewPrice", item);
                    Vue.set(park, "Amount", priceSivex.Amount);
                    Vue.set(park, "RateKey", priceSivex.RateKey);
                    const amount = parkSelected.reduce(
                        (acc, { Amount }) => acc + Amount,
                        0
                    );
                    
                    
                    priceSivex.Amount = amount;
                } else {
                    let chunkList = helper.methods.chunk(parkSelected, 5);
                    
                    let priceList = [];
                    let sivexPayData = [];

                    await Promise.all(
                        chunkList.map(async(el, idx) => {
                            if (chunkList.length > 1 && el.length < 5) {
                                let total = (chunkList.length - 1) * 5;
                                item.cantidad = el.length + total;
                            } else {
                                item.cantidad = el.length;
                            }

                            item.Parks = el;

                            let sivexData = {};
                            let price = await dispatch("GetNewPrice", item);
                            
                            sivexData.packageId = price.packageId;
                            sivexData.ServiceID = price.ServiceID;
                            sivexData.ServiceNumber = price.ServiceNumber;
                            sivexData.itineraryId = price.itineraryId;
                            sivexData.options = price.options;
                            sivexData.Amount = price.Amount;
                            sivexData.availableParks = parkSelected.map(
                                (item) => item.Park.Id
                            );

                            priceList.push(price);
                            sivexPayData.push(sivexData);
                            
                        })
                    );
                    let multiParks = {};
                    let amount = priceList.reduce(
                        (acc, { Amount }) => acc + Amount,
                        0
                    );

                    multiParks.Amount = amount;
                    multiParks.NormalIndividual =
                        multiParks.Amount / parkSelected.length;
                    multiParks.Parks = parkSelected;
                    multiParks.cantidad = parkSelected.length;
                    multiParks.sivexPayData = sivexPayData;

                    Vue.set(park, "Amount", amount);
                    priceSivex = {...item, ...multiParks };
                }

                commit("setCarrito", priceSivex);

                await dispatch("addShoppingCartAmount");
                await dispatch("getAmount");

                Vue.$toast.open({
                    message: i18n.t("messages.album_add_successfully"),
                    type: "success",
                });

                // Actualizamos el componente de Albums
                dispatch("updateAlbumComponent");
                // Actualizamos el componente del carrito
                dispatch("updateShoppingCartComponent");

                dispatch("setLoading", false);
            } catch (error) {
                dispatch("setLoading", false);

                Vue.set(park, "IsAdded", false);
                state.albumes[idx].FreeHotels = false;

                Vue.$toast.open({
                    message: i18n.t("messages.album_error_add"),
                    type: "error",
                });

                dispatch("updateAlbumComponent");
                
            }
        },
        async addCartByServiceId({ commit, dispatch, state }, { park, tag, reservation = false }) {
            try {
                /* It's calling the action `setLoading` and passing the value `true` to it. */
                dispatch("setLoading", true);

                const parkId = park.Park.Id;

                let item = {
                    id: uuidv4(),
                    cantidad: 1,
                    ParkID: parkId,
                    uuid: tag,
                    BookID: null,
                    ServiceId: park.CustomService,
                    type: 1,
                    TotalMedia: park.TotalMedia,
                    IsOnlyHotel: false,
                    tags: [{
                        Tag: tag,
                        VisitedOn: park.VisitDate,
                        ParkId: parkId,
                    }, ],
                    park,
                    Id: 0,
                    date: moment().format("YYYY-MM-DD"),
                    Amount: 0,
                    NormalIndividual: 0,
                    RateKey: "",
                };

                if (reservation) {
                    item.BookID = park.Reservation.BookId;
                    item.Room = park.Reservation.Room;
                }

                let p = await dispatch("GetNewPrice", item);
                
                
                p.VisitDate = park.VisitDate;
                /* It's setting a property on the park object. */
                Vue.set(park, "IsAdded", true);

                commit("setCarrito", p);

                await dispatch("addShoppingCartAmount");
                await dispatch("getAmount");

                Vue.$toast.open({
                    message: i18n.t("messages.album_add_successfully"),
                    type: "success",
                });

                // Actualizamos el componente de Albums
                dispatch("updateAlbumComponent");
                // Actualizamos el componente del carrito
                dispatch("updateShoppingCartComponent");

                dispatch("setLoading", false);
            } catch (error) {
                dispatch("setLoading", false);

                Vue.set(park, "IsAdded", false);

                Vue.$toast.open({
                    message: i18n.t("messages.album_error_add"),
                    type: "error",
                });
            }
        },
        /**
         * It's adding a park to the shopping cart
         * @param park - This is the park that we're adding to the cart.
         * @returns the value of the `park` object.
         */
        async addCartByTag({ commit, dispatch, state }, park) {
            try {
                /* It's calling the action `setLoading` and passing the value `true` to it. */
                dispatch("setLoading", true);

                const parkId = park.Park.Id;
                let cantidad = state.shoppingCart.hasOwnProperty(parkId) ?
                    state.shoppingCart[parkId].cantidad + 1 :
                    1;

                let totalMedia = state.shoppingCart.hasOwnProperty(parkId) ?
                    state.shoppingCart[parkId].TotalMedia :
                    0;

                let TotalPhotos = totalMedia + park.TotalMedia;

                let item = {
                    id: uuidv4(),
                    cantidad: cantidad,
                    Pax: park.Reservation.Pax,
                    ParkID: parkId,
                    type: 1,
                    BookID: null,
                    IsOnlyHotel: false,
                    TotalMedia: TotalPhotos,
                    Id: 0,
                    date: moment().format("YYYY-MM-DD"),
                    Amount: 0,
                    NormalIndividual: 0,
                    RateKey: "",
                };

                //Cuando es Xenotes se toman los Pax que vienen en las propiedad del álbum
                //ToD0: Hay que pulir esta funcionalidad en caso de que otros parques manejen
                //      el mismo esquema.
                if (parkId == 3) {
                    let newPax = park.Reservation.Pax;

                    item.Pax = state.shoppingCart.hasOwnProperty(parkId) ?
                        state.shoppingCart[parkId].Pax + newPax :
                        newPax;
                }

                let p = await dispatch("GetNewPrice", item);
                
                
                p.VisitDate = park.VisitDate;
                /* It's setting a property on the park object. */
                Vue.set(park, "IsAdded", true);
                // We obtain all the tags, which are associated with the sale
                let tagsItems = [];
                let tags = Object.values(state.albumes)
                    .filter((item) => item.ParkID == parkId && item.Type == 1)
                    .map(function(item) {
                        item.Tags.map((tag) => {
                            tagsItems.push({ Tag: tag, VisitedOn: item.VisitDate, ParkId: parkId });
                        });
                    });

                p.tags = tagsItems;

                commit("setCarrito", p);

                await dispatch("addShoppingCartAmount");
                await dispatch("getAmount");

                // Actualizamos el componente de Albums
                dispatch("updateAlbumComponent");
                // Actualizamos el componente del carrito
                dispatch("updateShoppingCartComponent");

                Vue.$toast.open({
                    message: i18n.t("messages.album_add_successfully"),
                    type: "success",
                });

                dispatch("setLoading", false);
            } catch (error) {
                dispatch("setLoading", false);

                Vue.set(park, "IsAdded", false);

                Vue.$toast.open({
                    message: i18n.t("messages.album_error_add"),
                    type: "error",
                });
                
            }
        },
        /**
         * It's calling the action `setLoading` and passing the value `true` to it
         */
        async addCartByRoom({ commit, dispatch, state }, { park, idx }) {
            try {
                /* It's calling the action `setLoading` and passing the value `true` to it. */
                dispatch("setLoading", true);

                if (park.CustomService !== null) {
                    let uuid = uuidv4();
                    park.uuid = uuid;
                    await dispatch("addCartByServiceId", {
                        park,
                        tag: uuid,
                        reservation: true,
                    });
                    return;
                }

                Vue.set(park, "IsAdded", true);

                // Recuperamos los albumes que solo son Parques y descartando los que son hoteles y los que son servicios personalizados
                let Parks = state.albumes[idx].park.filter((data) => data.IsAdded && !data.Park.IsHotel && data.CustomService === null);

                if (Parks.length) {
                    state.albumes[idx].park.map(function(data) {
                        if (
                            data.Park.IsHotel &&
                            data.IsAdded &&
                            data.CustomService === null
                        ) {
                            data.IsAdded = false;
                            state.shoppingCart[park.Reservation.BookId]
                                .cantidad--;
                        }
                    });
                }

                // Recuperamos los albumes que solo son de Hoteles
                let Hotels = state.albumes[idx].park.filter(
                    (data) =>
                    data.IsAdded &&
                    data.Park.IsHotel &&
                    data.CustomService === null
                );

                // Si se encuentra solo agregado un hotel y sin parques se cotiza solo el numero de hoteles
                // De lo contrario si no se encuntran hoteles y so hay parques solo se cotizan los parques aun que se tengan hoteles seleccionados
                let parkSelected = Hotels.length && !Parks.length ? Hotels : Parks;

                state.albumes[idx].FreeHotels = Parks.length;

                let pax = park.Reservation.Pax;
                let isOnlyHotel = Hotels.length;
                let parkId = isOnlyHotel ? park.Park.Id : parseInt(park.Reservation.HotelId);

                // Verificamos si en los valores solo llega seleccion de hotel
                let item = {
                    Room: parseInt(state.albumes[idx].code),
                    BookID: parseInt(park.Reservation.BookId),
                    cantidad: parkSelected.length,
                    Pax: pax,
                    ParkID: parkId,
                    Parks: parkSelected,
                    IsOnlyHotel: isOnlyHotel,
                    type: 2,
                    date: moment().format("YYYY-MM-DD"),
                    Id: 0,
                    Amount: 0,
                    NormalIndividual: 0,
                    RateKey: "",
                };

                

                let priceSivex = {};
                /*
                 *   Obtenemos todos los precios regulares de los hoteles agregados y sumamos. Actualizamos el Amount total para que
                 *   la funcion Amount actualice los valores y se actualice el componente.
                 */
                if (Hotels.length) {
                    priceSivex = await dispatch("GetNewPrice", item);
                    Vue.set(park, "Amount", priceSivex.Amount);
                    Vue.set(park, "RateKey", priceSivex.RateKey);
                    const amount = parkSelected.reduce(
                        (acc, { Amount }) => acc + Amount,
                        0
                    );
                    
                    
                    priceSivex.Amount = amount;
                } else {
                    let chunkList = helper.methods.chunk(parkSelected, 5);
                    
                    let priceList = [];
                    let sivexPayData = [];

                    await Promise.all(
                        chunkList.map(async(el, idx) => {
                            if (chunkList.length > 1 && el.length < 5) {
                                let total = (chunkList.length - 1) * 5;
                                item.cantidad = el.length + total;
                            } else {
                                item.cantidad = el.length;
                            }

                            item.Parks = el;

                            let sivexData = {};
                            let price = await dispatch("GetNewPrice", item);
                            
                            sivexData.packageId = price.packageId;
                            sivexData.ServiceID = price.ServiceID;
                            sivexData.ServiceNumber = price.ServiceNumber;
                            sivexData.itineraryId = price.itineraryId;
                            sivexData.options = price.options;
                            sivexData.Amount = price.Amount;
                            sivexData.availableParks = parkSelected.map(
                                (item) => item.Park.Id
                            );

                            priceList.push(price);
                            sivexPayData.push(sivexData);
                            
                        })
                    );

                    let multiParks = {};
                    let amount = priceList.reduce(
                        (acc, { Amount }) => acc + Amount,
                        0
                    );

                    multiParks.Amount = amount;
                    multiParks.NormalIndividual =
                        multiParks.Amount / parkSelected.length;
                    multiParks.Parks = parkSelected;
                    multiParks.cantidad = parkSelected.length;
                    multiParks.sivexPayData = sivexPayData;

                    Vue.set(park, "Amount", amount);

                    priceSivex = {...item, ...multiParks };
                }

                commit("setCarrito", priceSivex);

                await dispatch("addShoppingCartAmount");
                await dispatch("getAmount");

                Vue.$toast.open({
                    message: i18n.t("messages.album_add_successfully"),
                    type: "success",
                });

                // Actualizamos el componente de Albums
                dispatch("updateAlbumComponent");
                // Actualizamos el componente del carrito
                dispatch("updateShoppingCartComponent");

                dispatch("setLoading", false);
            } catch (error) {
                dispatch("setLoading", false);

                Vue.set(park, "IsAdded", false);
                state.albumes[idx].FreeHotels = false;

                Vue.$toast.open({
                    message: i18n.t("messages.album_error_add"),
                    type: "error",
                });

                dispatch("updateAlbumComponent");
                
            }
        },
        /* Getting the amount of items in the shopping cart. */
        async getAmount({ state, commit }) {
            const amount = Object.values(state.shoppingCart).reduce(
                (acc, { Amount }) => acc + Amount,
                0
            );

            commit("SET_AMOUNT", amount);
        },
        /* Getting the amount of items in the shopping cart. */
        async getShoppingCartAmount({ state }) {
            return Object.values(state.shoppingCart).reduce(
                (acc, { cantidad }) => acc + cantidad,
                0
            );
        },
        /* Calling the getShoppingCartAmount method and then committing the result to the
        SET_SHOPPING_CART_AMOUNT mutation. */
        async addShoppingCartAmount({ commit, dispatch }) {
            let amount = await dispatch("getShoppingCartAmount");
            commit("SET_SHOPPING_CART_AMOUNT", amount);
        },
        async removeShoppingCartAmount({ commit, dispatch }) {
            let amount = (await dispatch("getShoppingCartAmount")) - 1;
            
            // state.shoppingCartAmount
            commit("SET_SHOPPING_CART_AMOUNT", amount);
        },
        AddNewPrice({ commit }, data) {
            commit("setCarrito", data);
        },
        /**
         * Refresh all the cart information;
         */
        async refreshShoppingCart({ commit, dispatch }) {
            eventBus.$emit("addShoppingCart", { uuid: uuidv4() });
            await dispatch("addShoppingCartAmount");
            commit("CREATE_NEW_KEY_COMPONENT", uuidv4());
            await dispatch("getAmount");
            Vue.$toast.open({
                message: i18n.t("messages.album_remove_successfully"),
                type: "success",
            });
        },
        /**
         * Funcion para desasociar un parque completo del carrito, sin importar el numero de tags que tenga.
         * @param {*} parkId
         * @EstadoActual : funcion usanda en ShoppingCartComponent
         */
        async removeParkFromShoppingCart({ commit, dispatch, state }, parkId) {
            dispatch("setLoading", true);

            state.albumes
                .filter(
                    (album) =>
                    album.Type === 1 && album.ParkID === parseInt(parkId)
                )
                .map((album) => {
                    album.park.map((park) => {
                        if (park.CustomService === null) {
                            park.IsAdded = false;
                        }
                    });
                });

            delete state.shoppingCart[parkId];
            await dispatch("refreshShoppingCart");
            dispatch("setLoading", false);
        },
        async removeCodeFromShoppingCart({ commit, dispatch, state }, { park, idx = null, downloadCode = null }) {
            try {
                dispatch("setLoading", true);
                if (idx === null) {
                    idx = Object.values(state.albumes).findIndex(
                        (item) => item.code == downloadCode
                    );
                    
                }

                const code = state.albumes[idx].code;
                
                if (state.shoppingCart[code].cantidad === 1) {
                    Vue.set(park, "IsAdded", false);
                    delete state.shoppingCart[code];
                } else {
                    Vue.set(park, "IsAdded", false);
                    let album = state.albumes[idx];
                    let parks = album.park.filter((item) => item.IsAdded);
                    const Amount = parks.reduce(
                        (acc, { price }) => acc + price.Amount,
                        0
                    );
                    const cantidad = state.shoppingCart[code].cantidad - 1;
                    let item = {
                        id: uuidv4(),
                        code: code,
                        cantidad: cantidad,
                        Parks: parks,
                        type: 0,
                        Id: 0,
                        date: moment().format("YYYY-MM-DD"),
                        Amount: Amount,
                        NormalIndividual: 0,
                        RateKey: "",
                    };
                    commit("setCarrito", item);
                }
                await dispatch("refreshShoppingCart");

                // Actualizamos el componente de Albums
                dispatch("updateAlbumComponent");
                // Actualizamos el componente del carrito
                dispatch("updateShoppingCartComponent");

                dispatch("setLoading", false);
            } catch (error) {
                dispatch("setLoading", false);
                
                Vue.set(park, "IsAdded", true);
                Vue.$toast.open({
                    message: i18n.t("messages.album_error_remove"),
                    type: "error",
                });
            }
        },
        async removeBookParkFromShoppingCart({ commit, dispatch, state }, { room, parkIndex, item }) {
            try {
                let pax = item.Pax;
                dispatch("setLoading", true);

                const deletedPark = state.shoppingCart[room].Parks[parkIndex];
                if (state.shoppingCart[room].cantidad === 1) {
                    await dispatch("enableAddItemByBook", {
                        deletedPark: null,
                        room: room,
                    });
                    delete state.shoppingCart[room];
                } else {
                    let hotelCounter = 0; //this should be a boolean
                    let parkCounter = 0;

                    state.shoppingCart[room].Parks.splice(parkIndex, 1);

                    const BookAlbumDate = state.shoppingCart[room]; //To get and validad how many albums still have the book

                    await dispatch("enableAddItemByBook", {
                        deletedPark: deletedPark,
                        room: room,
                    });
                    BookAlbumDate.Parks.filter((bookPark) =>
                        bookPark.Park.IsHotel === 0 ? hotelCounter + 1 : parkCounter + 1
                    );
                    // Verificamos si en los valores solo llega seleccion de hotel
                    const item = {
                        Room: room,
                        BookID: 0,
                        cantidad: state.shoppingCart[room].cantidad - 1,
                        Pax: pax,
                        ParkID: state.shoppingCart[room].ParkID, //This should be any hotels id (8,11,14(I guess)) and it comes from ShoppingCart
                        Parks: state.shoppingCart[room].Parks, //This comes from shoppingCart
                        type: 2,
                        //if by default any park will have false, but if not the hotelcounter wil be evaluate
                        //to validad if it has anyvalue will be a true.
                        IsOnlyHotel: hotelCounter > 0,
                        // TotalMedia: TotalPhotos,
                        Id: 0,
                        Amount: 0,
                        NormalIndividual: 0,
                        RateKey: "",
                    };

                    commit("setCarrito", await dispatch("GetNewPrice", item));
                }
                await dispatch("refreshShoppingCart");
                dispatch("setLoading", false);
            } catch (error) {
                
                dispatch("setLoading", false);
                Vue.$toast.open({
                    message: i18n.t("messages.album_error_remove"),
                    type: "error",
                });
            }
        },
        async removeParkServiceIdFromShoppingCart({ commit, dispatch, state }, { park, tag }) {
            try {
                dispatch("setLoading", true);
                delete state.shoppingCart[tag];
                Vue.set(park, "IsAdded", false);

                await dispatch("refreshShoppingCart");
                dispatch("setLoading", false);
            } catch (error) {
                dispatch("setLoading", false);
                
                Vue.set(park, "IsAdded", true);
                Vue.$toast.open({
                    message: i18n.t("messages.album_error_remove"),
                    type: "error",
                });
            }
        },
        /**
         * Funcion para eliminar albumnes de un parque en el carrito
         * @param {*} album current album data
         * @param {int} albumIndex current album position
         * @EstadoActual : se utiliza en el componente Albumes lines: 287
         * OK
         */
        async removeAlbumFromShoppingCart({ commit, dispatch, state }, { album, albumIndex }) {
            dispatch("setLoading", true);
            album.IsAdded = false;

            const parkId = album.Park.Id;
            const albumTotalMedia = album.TotalMedia;
            const itemCurrentQuantity = state.shoppingCart[parkId].cantidad;

            let item = {
                id: uuidv4(),
                cantidad: itemCurrentQuantity - 1,
                ParkID: parkId,
                type: 1,
                TotalMedia: state.shoppingCart[parkId].TotalMedia - albumTotalMedia,
                Id: 0,
                Amount: 0,
                NormalIndividual: 0,
                RateKey: "",
            };

            if (parkId == 3) {
                let newPax = album.Reservation.Pax;

                item.Pax = state.shoppingCart.hasOwnProperty(parkId) ?
                    state.shoppingCart[parkId].Pax - newPax :
                    newPax;
            }

            let tagsItems = [];
            let tags = Object.values(state.albumes)
                .filter((item) => item.ParkID == parkId && item.Type == 1)
                .map(function(item) {
                    item.park.map((park) => {
                        if (park.IsAdded && park.CustomService === null) {
                            tagsItems.push({
                                Tag: item.code,
                                VisitedOn: item.VisitDate,
                                ParkId: parkId,
                            });
                        }
                    });
                });

            item.tags = tagsItems;

            if (itemCurrentQuantity === 1) {
                delete state.shoppingCart[parkId];
            } else {
                let newPrice = await dispatch("GetNewPrice", item);
                commit("setCarrito", newPrice);
            }

            await dispatch("refreshShoppingCart");
            dispatch("setLoading", false);
        },
        /**
         * Funcion para habilitar el boton de agregar a uno o mas item de un algum de hotel
         * @param {*} deletedPark
         *
         */
        async enableAddItemByBook({ state }, { deletedPark, room }) {
            let currentAlbumIndex;
            state.albumes.filter((album, albumIndex) => {
                if (
                    parseInt(album.code) === room &&
                    parseInt(album.Type) === 2
                ) {
                    currentAlbumIndex = albumIndex;
                    album.park.filter((pk) => {
                        if (deletedPark) {
                            if (pk.AlbumKey.Id === deletedPark.AlbumKey.Id) {
                                pk.IsAdded = false;
                            }
                        } else {
                            pk.IsAdded = false;
                        }
                    });
                }
            });
            /**
             * todo: this is uggly, this should be refactor
             */
            if (!deletedPark) {
                //why this should have a free hotels in 0
                state.albumes[currentAlbumIndex].FreeHotels = 0;
            }
        },
        /**
         * Funcion para habilitar el boton de agregar a uno o mas item de un algum de hotel
         * @param {*} deletedPark
         *
         */
        async enableAddItemByCode({ state }, { deletedPark, code }) {
            let currentAlbumIndex;
            state.albumes.filter((album, albumIndex) => {
                if (album.code === code && parseInt(album.Type) === 0) {
                    currentAlbumIndex = albumIndex;
                    album.park.filter((pk) => {
                        if (deletedPark) {
                            if (pk.AlbumKey.Id === deletedPark.AlbumKey.Id) {
                                pk.IsAdded = false;
                            }
                        } else {
                            pk.IsAdded = false;
                        }
                    });
                }
            });
            /**
             * todo: this is uggly, this should be refactor
             */
            if (!deletedPark) {
            }
        },
        /**
         * Unused function
         * @param {*} param0
         * @param {*} producto
         */
        async removeShoppingCartByTag({ commit, dispatch, state }, producto) {
            try {
                dispatch("setLoading", true);

                let getTotalPax = (state.shoppingCart[
                    producto.ParkID
                ].cantidad = state.shoppingCart[producto.ParkID].cantidad - 1);

                let TotalPhotos = (state.shoppingCart[
                        producto.ParkID
                    ].TotalMedia =
                    state.shoppingCart[producto.ParkID].TotalMedia -
                    producto.TotalMedia);

                let item = {
                    id: Date.now() +
                        "-" +
                        Math.random().toString(36).substring(2, 5),
                    cantidad: getTotalPax,
                    ParkID: producto.ParkID,
                    type: 1,
                    TotalMedia: TotalPhotos,
                    Id: 0,
                    Amount: 0,
                    NormalIndividual: 0,
                    RateKey: "",
                };

                if (state.shoppingCart[producto.ParkID].cantidad === 0) {
                    producto.IsAdded = false;

                    Object.values(state.albumes).filter((album, index) => {
                        album.IsAdded = false;
                    });
                    delete state.shoppingCart[producto.ParkID];
                    
                } else {
                    let p = await dispatch("GetNewPrice", item);
                    
                    /* It's setting a property on the producto object. */
                    producto.IsAdded = false;
                    commit("setCarrito", p);
                }

                eventBus.$emit("addShoppingCart", {
                    uuid: uuidv4(),
                });

                await dispatch("addShoppingCartAmount");
                await dispatch("getAmount");
                Vue.$toast.open({
                    message: i18n.t("messages.album_remove_successfully"),
                    type: "success",
                });

                // Actualizamos el componente de Albums
                dispatch("updateAlbumComponent");
                // Actualizamos el componente del carrito
                dispatch("updateShoppingCartComponent");
                dispatch("setLoading", false);
            } catch (error) {
                dispatch("setLoading", false);
                Vue.$toast.open({
                    message: i18n.t("messages.album_error_remove"),
                    type: "error",
                });
                
            }
        },
        async removeShoppingCartByRoom({ commit, dispatch, state }, { park, idx, room = null }) {
            try {
                dispatch("setLoading", true);

                if (room != null) {
                    idx = state.albumes.findIndex(
                        (item) => item.code.toString() == room.toString()
                    );
                }

                Vue.set(park, "IsAdded", false);
                const code = state.albumes[idx].code;
                let bookId = park.Reservation.BookId.toString();

                // Verificamos si existe el Custom para usar el uuid que identifica el nodo a eliminar
                if (park.CustomService !== null) {
                    bookId = park.uuid;
                }

                if (state.shoppingCart[bookId].cantidad == 1) {
                    delete state.shoppingCart[bookId];

                    if (park.CustomService === null)
                        state.albumes[idx].FreeHotels = 0;
                } else {
                    // Recuperamos los albumes que solo son Parques y descartando los que son hoteles y los que son servicios personalizados
                    let Parks = state.albumes[idx].park.filter((data) => data.IsAdded && !data.Park.IsHotel && data.CustomService === null);

                    // Recuperamos los albumes que solo son de Hoteles
                    let Hotels = state.albumes[idx].park.filter((data) => data.IsAdded && data.Park.IsHotel && data.CustomService === null);

                    // Si se encuentra solo agregado un hotel y sin parques se cotiza solo el numero de hoteles
                    // De lo contrario si no se encuntran hoteles y so hay parques solo se cotizan los parques aun que se tengan hoteles seleccionados
                    let parkSelected = Hotels.length && !Parks.length ? Hotels : Parks;

                    let parksHotels = state.albumes[idx].park.filter((data) => data.IsAdded && data.CustomService === null);

                    let cantidad = Object.keys(state.shoppingCart).indexOf(bookId) > -1 ? state.shoppingCart[bookId].cantidad - 1 : 1;
                    let pax = park["Reservation"]["Pax"];
                    let isOnlyHotel = park.Park.IsHotel;
                    let parkId = isOnlyHotel ? park.Park.Id : parseInt(park.Reservation.HotelId);
                    
                    // Verificamos si en los valores solo llega seleccion de hotel
                    let item = {
                        Room: parseInt(code),
                        BookID: parseInt(bookId),
                        cantidad: cantidad,
                        Pax: pax,
                        ParkID: parkId,
                        Parks: parksHotels,
                        type: 2,
                        IsOnlyHotel: isOnlyHotel,
                        Id: 0,
                        Amount: 0,
                        NormalIndividual: 0,
                        RateKey: "",
                    };

                    let priceSivex = {};
                    /*
                     *   Obtenemos todos los precios regulares de los hoteles agregados y sumamos. Actualizamos el Amount total para que
                     *   la funcion Amount actualice los valores y se actualice el componente.
                     */
                    if (Hotels.length) {
                        priceSivex = await dispatch("GetNewPrice", item);
                        Vue.set(park, "Amount", priceSivex.Amount);
                        Vue.set(park, "RateKey", priceSivex.RateKey);
                        const amount = parkSelected.reduce(
                            (acc, { Amount }) => acc + Amount,
                            0
                        );
                        
                        
                        priceSivex.Amount = amount;
                    } else {
                        let chunkList = helper.methods.chunk(parkSelected, 5);
                        
                        let priceList = [];
                        let sivexPayData = [];

                        await Promise.all(
                            chunkList.map(async(el, idx) => {
                                item.cantidad = el.length;
                                item.Parks = el;

                                let sivexData = {};
                                let price = await dispatch("GetNewPrice", item);
                                
                                sivexData.packageId = price.packageId;
                                sivexData.ServiceID = price.ServiceID;
                                sivexData.itineraryId = price.itineraryId;
                                sivexData.options = price.options;
                                sivexData.Amount = price.Amount;
                                sivexData.availableParks = el.map(
                                    (item) => item.Park.Id
                                );

                                priceList.push(price);
                                sivexPayData.push(sivexData);
                                
                            })
                        );

                        let multiParks = {};
                        let amount = priceList.reduce(
                            (acc, { Amount }) => acc + Amount,
                            0
                        );

                        multiParks.Amount = amount;
                        multiParks.NormalIndividual =
                            multiParks.Amount / parkSelected.length;
                        multiParks.Parks = parkSelected;
                        multiParks.cantidad = parkSelected.length;
                        multiParks.sivexPayData = sivexPayData;

                        Vue.set(park, "Amount", amount);
                        priceSivex = {...item, ...multiParks };
                    }

                    commit("setCarrito", priceSivex);
                }

                await dispatch("addShoppingCartAmount");
                await dispatch("getAmount");

                Vue.$toast.open({
                    message: i18n.t("messages.album_remove_successfully"),
                    type: "success",
                });

                // Actualizamos el componente de Albums
                dispatch("updateAlbumComponent");
                // Actualizamos el componente del carrito
                dispatch("updateShoppingCartComponent");
                dispatch("setLoading", false);
            } catch (error) {
                dispatch("setLoading", false);
                Vue.$toast.open({
                    message: i18n.t("messages.album_error_remove"),
                    type: "error",
                });

                // Actualizamos el componente de Albums
                dispatch("updateAlbumComponent");
                // Actualizamos el componente del carrito
                dispatch("updateShoppingCartComponent");
                
            }
        },
        async removeShoppingCartByDownloadCode({ commit, dispatch, state }, { park, idx, code = null }) {
            try {
                dispatch("setLoading", true);

                if (code != null) {
                    idx = state.albumes.findIndex(
                        (item) => item.code.toString() == code.toString()
                    );
                }

                Vue.set(park, "IsAdded", false);
                const downloadCode = state.albumes[idx].code;
                let bookId = park.Reservation.BookId.toString();

                // Verificamos si existe el Custom para usar el uuid que identifica el nodo a eliminar
                if (park.CustomService !== null) {
                    bookId = park.uuid;
                }

                if (state.shoppingCart[downloadCode].cantidad == 1) {
                    delete state.shoppingCart[downloadCode];

                    if (park.CustomService === null)
                        state.albumes[idx].FreeHotels = 0;
                } else {
                    let Parks = state.albumes[idx].park.filter(
                        (data) => data.IsAdded && !data.Park.IsHotel
                    );

                    let Hotels = state.albumes[idx].park.filter(
                        (data) => data.IsAdded && data.Park.IsHotel
                    );

                    // Si se encuentra solo agregado un hotel y sin parques se cotiza solo el numero de hoteles
                    // De lo contrario si no se encuntran hoteles y so hay parques solo se cotizan los parques aun que se tengan hoteles seleccionados
                    let parkSelected =
                        Hotels.length && !Parks.length ? Hotels : Parks;

                    let parksHotels = state.albumes[idx].park.filter(
                        (data) => data.IsAdded && data.CustomService === null
                    );

                    let cantidad =
                        Object.keys(state.shoppingCart).indexOf(downloadCode) >
                        -1 ?
                        state.shoppingCart[downloadCode].cantidad - 1 :
                        1;
                    let pax = park["Reservation"]["Pax"];
                    
                    // Verificamos si en los valores solo llega seleccion de hotel
                    let item = {
                        code: downloadCode,
                        Room: parseInt(downloadCode),
                        BookID: parseInt(bookId),
                        cantidad: cantidad,
                        Pax: pax,
                        ParkID: parseInt(park.Reservation.HotelId),
                        Parks: parksHotels,
                        type: 0,
                        IsOnlyHotel: park.Park.IsHotel,
                        // TotalMedia: TotalPhotos,
                        Id: 0,
                        Amount: 0,
                        NormalIndividual: 0,
                        RateKey: "",
                    };

                    let priceSivex = {};
                    /*
                     *   Obtenemos todos los precios regulares de los hoteles agregados y sumamos. Actualizamos el Amount total para que
                     *   la funcion Amount actualice los valores y se actualice el componente.
                     */
                    if (Hotels.length) {
                        priceSivex = await dispatch("GetNewPrice", item);
                        Vue.set(park, "Amount", priceSivex.Amount);
                        Vue.set(park, "RateKey", priceSivex.RateKey);
                        const amount = parkSelected.reduce(
                            (acc, { Amount }) => acc + Amount,
                            0
                        );
                        
                        
                        priceSivex.Amount = amount;
                    } else {
                        let chunkList = helper.methods.chunk(parkSelected, 5);
                        
                        let priceList = [];
                        let sivexPayData = [];

                        await Promise.all(
                            chunkList.map(async(el, idx) => {
                                item.cantidad = el.length;
                                item.Parks = el;

                                let sivexData = {};
                                let price = await dispatch("GetNewPrice", item);
                                
                                sivexData.packageId = price.packageId;
                                sivexData.ServiceID = price.ServiceID;
                                sivexData.itineraryId = price.itineraryId;
                                sivexData.options = price.options;
                                sivexData.Amount = price.Amount;
                                sivexData.availableParks = el.map(
                                    (item) => item.Park.Id
                                );

                                priceList.push(price);
                                sivexPayData.push(sivexData);
                                
                            })
                        );

                        let multiParks = {};
                        let amount = priceList.reduce(
                            (acc, { Amount }) => acc + Amount,
                            0
                        );

                        multiParks.Amount = amount;
                        multiParks.NormalIndividual =
                            multiParks.Amount / parkSelected.length;
                        multiParks.Parks = parkSelected;
                        multiParks.cantidad = parkSelected.length;
                        multiParks.sivexPayData = sivexPayData;

                        Vue.set(park, "Amount", amount);
                        priceSivex = {...item, ...multiParks };
                    }

                    commit("setCarrito", priceSivex);
                }

                await dispatch("addShoppingCartAmount");
                await dispatch("getAmount");

                Vue.$toast.open({
                    message: i18n.t("messages.album_remove_successfully"),
                    type: "success",
                });

                // Actualizamos el componente de Albums
                dispatch("updateAlbumComponent");
                // Actualizamos el componente del carrito
                dispatch("updateShoppingCartComponent");
                dispatch("setLoading", false);
            } catch (error) {
                dispatch("setLoading", false);
                Vue.$toast.open({
                    message: i18n.t("messages.album_error_remove"),
                    type: "error",
                });

                // Actualizamos el componente de Albums
                dispatch("updateAlbumComponent");
                // Actualizamos el componente del carrito
                dispatch("updateShoppingCartComponent");
                
            }
        },
        removeItemShoppingCart({ commit, dispatch }, data) {
            commit("SET_REMOVE_ITEM_SHOPPING_CART", data);
            dispatch("addShoppingCartAmount");
            // Actualizamos el componente de Albums
            dispatch("updateAlbumComponent");
            dispatch("getAmount");
        },
        removeItemByTagCart({ commit, dispatch }, { visitDate, parkId }) {
            commit("REMOVE_ITEM_BY_TAG_CART", { visitDate, parkId });
            dispatch("addShoppingCartAmount");
            // Actualizamos el componente de Albums
            dispatch("updateAlbumComponent");
            dispatch("getAmount");
        },
        updateAlbum({ commit, dispatch }, data) {
            commit("SET_UPDATE_ALBUM_PV", data);
        },
        clearShoppingCart({ commit }) {
            commit("SET_CLEAR_ALBUMES");
        },
        deleteDownloadCodesInAlbums({ commit }) {
            commit("SET_DELETE_DOWNLOAD_CODES_IN_ALBUMS");
        },
        cleanAfterShopping({ commit, state }) {
            // verificamos si existe algun Tag en el carrito
            const hasTagsinShoppingCart = Object.values(
                state.shoppingCart
            ).some((item) => item.type === 1);
            // verificamos si existe algun Tag en el carrito
            // const hasTagsinShoppingCart = Object.values(state.shoppingCart).some(item => item.type === 1);

            if (hasTagsinShoppingCart) {
                commit("SET_REMOVE_TAGS_PURCHASED_ALBUMS");
            }

            // Limpiamos el Carrito
            commit("SET_CLEAR_SHOPPING_CART");
            // Habilitamos el TAB de Codigos de descarga
            state.tabDownloadCode = true;
            // Seleccionamos el tab de Codigo de descarga como preterminado
            state.typeCodeTab = 0;
        },
        SelectParkRoom({ commit, state }, data) {
            commit("SET_SELECT_PARK_ROOM", data);
        },
        EnableAddButtomCart({ commit, state }, data) {
            commit("SET_ENABLE_ADD_BUTTOM_CART", data);
        },
        AddParks({ commit }, data) {
            commit("SET_PARKS", data);
        },
        SetBanks({ commit }, data) {
            commit("SET_BANKS", data);
        },
        SetSafetyPayBanks({ commit }, data) {
            commit("SET_SAFETY_PAY_BANKS", data);
        },
    },
    getters: {
        getLanguage(state) {
            return state.Language;
        },
        updateAlbumComponent(state) {
            return state.componentes.album;
        },
        uuidShoppingCartComponent(state) {
            return state.componentes.shoppingCart;
        },
        getIPAddress(state) {
            return state.IPAddress;
        },
        getLoading(state) {
            return state.loading;
        },
        userLoggedIn(state) {
            return state.userLoggedIn;
        },
        isGuest(state) {
            return state.isGuest;
        },
        Codes(state) {
            return state.codes;
        },
        GetParks(state) {
            return state.Parks;
        },
        Banks(state) {
            return state.Banks;
        },
        SafetyPayBanks(state) {
            return state.SafetyPayBanks;
        },
        Currency(state) {
            return state.Currency;
        },
        CurrentPrice(state) {
            return state.CurrentPrice;
        },
        shoppingCart(state) {
            return state.shoppingCart;
        },
        getCodesType(state) {
            const albumes = Object.values(state.albumes);

            let types = albumes.reduce(function(albumes, album) {
                if (album in albumes) {
                    albumes[album.Type]++;
                } else {
                    albumes[album.Type] = 1;
                }

                return albumes;
            }, {});

            let countTypes = Object.values(types).length;
            let banner =
                countTypes == 1 ?
                parseInt(Object.keys(types).shift()) :
                "default";
            
            return banner;
        },
        shoppingCartCounter(state) {
            return Object.values(state.shoppingCart).reduce(
                (acc, { cantidad }) => acc + cantidad,
                0
            );
        },
        Albumes(state) {
            return state.albumes;
        },
        needReloadAlbumes(state) {
            return state.needReloadAlbumes;
        },
        SpinningMultimedia(state) {
            return state.downloaded.spinning;
        },
        ProgressingMultimedia(state) {
            return state.downloaded.progressing;
        },
        CompressingMultimedia(state) {
            return state.downloaded.compressing;
        },
        downloaded(state) {
            return state.downloaded.data;
        },
        downloadedProgress(state) {
            return state.downloaded.progress;
        },
        CompressingZipCompressed(state) {
            return state.downloaded.compressingZip.compressed;
        },
        compressingZipTotal(state) {
            return state.downloaded.compressingZip.total;
        },
        CompletedDownload(state) {
            return state.downloaded.completed;
        },
        DownloadsBoxStatus(state) {
            return state.componentes.displayDownloadBox;
        },
        Contries(state) {
            return state.payment.countries;
        },
        CountryStates(state) {
            return state.payment.states;
        },
        getCurrency(state) {
            return state.Currency;
        },
        Amount(state) {
            return Object.values(state.shoppingCart).reduce(
                (acc, { cantidad, Amount }) => acc + Amount,
                0
            );
        },
        PaxWebsite(state) {
            return state.payment.pax.website;
        },
        PaxShoppingCart(state) {
            return state.payment.pax.shoppingCart;
        },
        existingSaleShoppingCart(state) {
            return Object.values(state.shoppingCart).some(
                (item) => item.type === 0
            );
        },
        // Validamos si presentar la opcion de pago con PayPal
        hasPayPal(state) {
            return state.CardTypes.some(el => el.cardTypeCode === 'PP');
        },
        getPackages(state){
            return state.albumes.filter( x => x.Type == 0 )
            .map((item) =>  item.getCode.PackageName );
        },
        someAlbumDownloadCode(state) {
            return Object.values(state.albumes).some((item) => item.Type);
        },
        authState(state) {
            return state.userLoggedIn || state.isGuest;
        },
        authStateLogged(state) {
            return state.userLoggedIn && !state.isGuest;
        },
        authStateGuest(state) {
            return state.userLoggedIn && state.isGuest;
        }
    },
});